module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Regular.76ba11aa.woff2";